import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { RecommendationTypeRequestDto } from '@/api/generated/HCA'

export const useRecommendationEditMutation = () => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (payload: { id: number; data: RecommendationTypeRequestDto }) =>
            hcaClientFactory.recommendationTypesApi.editRecommendationType(payload.id, payload.data),
        onSuccess: async (response, payload) => {
            await queryClient.invalidateQueries({
                queryKey: ['recommendation-types'],
            })

            await queryClient.invalidateQueries({
                queryKey: ['recommendation-types', payload.id],
            })

            await queryClient.invalidateQueries({ queryKey: ['constants'] })
        },
    })
}
